// extracted by mini-css-extract-plugin
export default {"description":"MovingHomeForm_description__AJ67P","title":"MovingHomeForm_title__gnY9U"};